<div [formGroup]="formGroup">
    <mat-label *ngIf="required && !readonly">{{ schema.label }} *</mat-label>
    <mat-label *ngIf="!required || readonly">{{ schema.label }}</mat-label>
    <maps-checkbox
        [schemaPai]="schemaParent"
        [schema]="schema"
        [formGroup]="formGroup"
        [readonly]="readonly"
        [parametrosRegra]="parametrosRegra"
    ></maps-checkbox>
</div>
